<template>
  <div class="modal-audio" v-if="isVisible" @click.self="closeModal">

    <div class="modal-content">
      <!-- <i @click.self="closeModal" class="guanbiicon el-icon-close"></i> -->
      <div class="modal-header">
        <div class="modal-icon">
          <!-- <i class="el-icon-microphone"></i> -->
          <img :src="audio_icon" alt="" />
        </div>
        <h2>Record or Upload Audio</h2>
      </div>
      <div class="recordtitle">
        <input placeholder="Please enter a title for the recording" v-model="recordtitle" clearable ref="recordInput" />
      </div>
      <selectlanguagein :chooeseLanguage="chooeseLanguagein" :chooeseLanguageName="chooeseLanguageNamein"
        @chooeselanguage="chooeselanguagein" />
      <selectlanguage :chooeseLanguage="chooeseLanguage" :chooeseLanguageName="chooeseLanguageName"
        @chooeselanguage="chooeselanguage" />
      <button class="record-button recordbtn" @click="goradiopage()">
        <!-- <i class="el-icon-microphone"></i> -->
        <i class="el-icon-mic"></i>Record Audio
      </button>
      <el-upload class="upload-demo" ref="uploadhome" :accept="acceptedFormats" action=""
        :disabled="chooeseLanguageName == ''" :http-request="uploadFile" :show-file-list="false"
        v-loading="taskisloading" element-loading-spinner="el-icon-loading" :element-loading-text="loadingText"
        element-loading-background="rgba(21, 23, 32, 0.8)">
        <button class="record-button" @click.stop="handleUploadClick()">
          <!-- <i class="el-icon-microphone"></i> -->
          <i class="el-icon-upload2"></i>Upload Audio Max size:{{ maxuploadsize }}M
        </button>
      </el-upload>

      <!-- <div class="uploadbox" v-loading="isloading" element-loading-spinner="el-icon-loading"
        element-loading-text="Uploading..." element-loading-background="rgba(21, 23, 32, 0.8)">
        <el-upload :class="{ 'upload-demo': true, }" :accept="acceptedFormats" action=""
          :disabled="chooeseLanguageName == ''" :http-request="uploadFile" :show-file-list="false" drag>
          <div :class="{ 'is-disabled': chooeseLanguageName == '' }">
            <div>
              <i class="el-icon-upload2"></i>
              <span>Drag .mp3 audio file here, or click to select</span>
            </div>
            <div class="tishi">{{ "Max size:80M" }}</div>
            <span class="tip"><i class="el-icon-info"></i>Tip: Select language available</span>
          </div>
        </el-upload>
      </div> -->

    </div>
  </div>
</template>

<script>
import selectlanguagein from "@/views/pages/home_page/popups/selectlanguagein.vue";
import selectlanguage from "@/views/pages/home_page/popups/selectlanguage.vue";
export default {
  name: "AudioModal",
  props: {
    uploadProgress: {
      type: Number,
      default: 0,
    },
    taskisloading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    selectlanguagein,
    selectlanguage,
  },
  data() {
    return {
      audio_icon: require("@/assets/images/home/audio_icon.png"),
      isVisible: false,
      // isloading: false,
      acceptedFormats: ".mp3,.wav,.flac,.aac,.ogg,.alac,.aiff,.m4a,.webm",

      chooeseLanguage: "",
      chooeseLanguageName: "",

      chooeseLanguagein: "",
      chooeseLanguageNamein: "",

      maxuploadsize: 140,

      recordtitle: "",

      islanguage: false,
      isMouseDownOnModal: false,

    };
  },
  computed: {
    loadingText() {
      return `Uploading... ${this.uploadProgress}%`;
    },
  },
  methods: {
    chooeselanguage(language, Languagename) {
      this.chooeseLanguage = language
      this.chooeseLanguageName = Languagename
      this.$emit("chooeselanguage", language, Languagename);
    },
    chooeselanguagein(language, Languagename) {
      this.chooeseLanguagein = language
      this.chooeseLanguageNamein = Languagename
      this.$emit("chooeselanguagein", language, Languagename);
    },
    handleUploadClick() {
      if (this.chooeseLanguageNamein == "" || !this.chooeseLanguageNamein) {
        this.$message.error("Please select a Audio language first");
        return
      }
      if (this.chooeseLanguageName == "" || !this.chooeseLanguageName) {
        this.$message.error("Please select a Note language first");
        return;
      }

      this.$refs.uploadhome.$el.querySelector('input[type="file"]').click();
      // 用户已登录，不做任何操作，让 el-upload 组件正常工作
    },
    goradiopage() {

      if (this.recordtitle == "") {
        this.$message.error("Please enter a title for the recording");
        return;
      }
      if (this.chooeseLanguageNamein == "" || !this.chooeseLanguageNamein) {
        this.$message.error("Please select a Audio language first");
        return;
      }
      if (this.chooeseLanguageName == "" || !this.chooeseLanguageName) {
        this.$message.error("Please select a Note language first");
        return;
      }
      this.$emit("setrecordtitle", this.recordtitle);
      this.$emit("home_chooseaside", "radio");
      this.closeModal();
    },
    openModal() {
      this.isVisible = true;
      this.$nextTick(() => {
        this.$refs.recordInput.focus();
      });
    },
    handleMouseDown() {
      this.isMouseDownOnModal = true;
    },
    handleClick() {
      if (!this.isMouseDownOnModal) {
        this.closeModal();
      }
      this.isMouseDownOnModal = false;  // 重置状态
    },
    closeModal() {
      this.isVisible = false;
    },
    uploadFile({ file }) {
      if (!file) {
        return;
      }

      // 验证文件类型
      const fileType = file.type;
      console.log(fileType);
      // console.log(fileType);
      const supportedTypes = [
        "audio/mpeg", // MP3
        "audio/wav", // WAV
        "audio/flac", // FLAC
        "audio/aac", // AAC
        "audio/ogg", // OGG
        "audio/alac", // ALAC
        "audio/aiff", // AIFF
        "audio/x-m4a", //M4A
        "audio/webm", // WEBM
        "video/webm", // WEBM
      ];

      if (!supportedTypes.includes(fileType)) {
        this.$message.error("Unsupported audio format");
        return;
      }
      // 验证文件大小
      const fileSize = file.size;
      if (fileSize > this.maxuploadsize * 1024 * 1024) {
        this.$message.error("File size exceeds " + this.maxuploadsize + "Mb");
        return;
      }

      // 替代方案1：使用音频元素获取时长
      const audioUrl = URL.createObjectURL(file);
      const audio = new Audio();

      audio.onloadedmetadata = () => {
        const duration = Math.round(audio.duration);
        console.log("Audio duration:", duration);

        let filename = file.name;
        if (this.recordtitle) {
          filename = this.recordtitle + "." + file.name.split(".")[1];
        }

        this.$parent.taskisloading = true;
        this.$emit("upload_audio", 'audio', file, filename, duration);

        // 释放对象URL
        URL.revokeObjectURL(audioUrl);
      };

      audio.onerror = (error) => {
        console.error("Error loading audio:", error);
        this.$message.error("Failed to get audio duration");
        URL.revokeObjectURL(audioUrl);
      };

      audio.src = audioUrl;
    },
  },
};
</script>

<style lang="less">
.modal-audio {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  .modal-header {
    text-align: center;
    margin-bottom: 28px;

    .modal-icon {
      background-color: #f0f7ff;
      width: 64px;
      height: 64px;
      border-radius: 50%;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 16px;
      padding: 14px;

      img {
        max-width: 32px;
      }

      i {
        font-size: 28px;
        color: #4a90e2;
      }
    }

    h2 {
      color: #1a1a1a;
      font-size: 20px;
      font-weight: 600;
      margin: 0;
      line-height: 1.4;
    }
  }

  .recordtitle {
    margin-bottom: 20px;

    input {
      width: 100%;
      padding: 14px 16px;
      border-radius: 12px;
      border: 1px solid #e0e0e0;
      background-color: #f8f9fa;
      color: #333333;
      font-size: 15px;
      transition: all 0.2s ease;
      box-sizing: border-box;

      &:focus {
        outline: none;
        border-color: #4a90e2;
        box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.1);
        background-color: #ffffff;
      }

      &::placeholder {
        color: #999999;
      }
    }
  }

  .upload-demo {
    width: 100%;
    color: #333333;

    i {
      font-weight: 600;
      margin-right: 8px;
      font-size: 18px;
    }

    .el-upload {
      width: 100%;
      display: block;
    }

    :deep(.el-upload) {
      width: 100%;
      display: block;
    }

    :deep(.el-upload-dragger) {
      width: 100%;
      display: block;
    }
  }

  .record-button {
    background-color: #4a90e2;
    color: white;
    border: none;
    border-radius: 12px;
    padding: 14px;
    width: 100%;
    font-size: 15px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(74, 144, 226, 0.2);

    &:hover {
      background-color: #357abd;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);
    }

    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
      transform: none;
      box-shadow: none;
    }
  }

  .recordbtn {
    background-color: #4CAF50;
    margin-top: 28px;

    &:hover {
      background-color: #43a047;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
    }
  }

  .modal-content {
    background-color: #ffffff;
    border-radius: 16px;
    padding: 32px;
    width: 500px;
    max-width: 90%;
    position: relative;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  }
}

:deep(.el-loading-mask) {
  background-color: rgba(255, 255, 255, 0.9) !important;
  border-radius: 16px;
}

:deep(.el-loading-text) {
  color: #4a90e2 !important;
  font-weight: 500;
}

:deep(.el-loading-spinner .path) {
  stroke: #4a90e2 !important;
}
</style>
